/// <amd-module name="Agile/Boards/Directory/BoardDirectory" />
import { AreaName } from "Agile/Boards/Directory/BoardDirectoryConstants";
import { IDirectoryArtifact, IDirectoryViewState } from "Agile/Directory/DirectoryContracts";
import { getDirectoryProviderProps, IDirectorySagaContext } from "Agile/Directory/Redux/getDirectoryProviderProps";
import * as React from "react";
import { IRootProviderProps, RootProvider } from "VSS/Redux/Deprecated/RootProvider";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { ConnectedBoardDirectoryContent } from "Agile/Boards/Directory/BoardDirectoryContent";

export class BoardDirectory extends VssComponent {
    private _hubViewState: VssHubViewState;
    private _rootProviderProps: IRootProviderProps<IDirectorySagaContext, IDirectoryViewState<IDirectoryArtifact>>;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);
        this._hubViewState = new VssHubViewState(context.pageContext);
        this._rootProviderProps = getDirectoryProviderProps(
            {
                myDataProviderId: "ms.vss-work-web.boards-hub-directory-data-provider",
                allDataProviderId: "ms.vss-work-web.boards-hub-all-directory-data-provider",
                hubName: AreaName
            },
            this._hubViewState,
            context.pageContext,
            AreaName
        );
    }

    public render(): JSX.Element {
        return (
            <RootProvider {...this._rootProviderProps}>
                <ConnectedBoardDirectoryContent hubViewState={this._hubViewState} />
            </RootProvider>
        );
    }
}

VssComponent.register("boardDirectory", BoardDirectory);
